module.exports = __webpack_public_path__ + "assets/music/epic/Road to Victory by Moonthief.ogg";